module.exports = __webpack_public_path__ + "static/media/yd_swiper_y.462b38d9.jpg";